import { Button } from '@/ui';
import { HolderOutlined } from '@ant-design/icons';
import { useRowContext } from '../../helpers';
import { COLORS } from '@/theme';

const DragButton = () => {
  const { setActivatorNodeRef, listeners } = useRowContext();
  return (
    <Button
      type="text"
      size="small"
      icon={<HolderOutlined style={{ background: `${COLORS.SOFT_GRAY}` }} />}
      style={{ cursor: 'move', background: `${COLORS.SOFT_GRAY}` }}
      ref={setActivatorNodeRef}
      {...listeners}
    />
  );
};

export default DragButton;
